import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogContent, IconButton, TextField, Typography, InputLabel, MenuItem, Select, FormControl, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadMediumModal = ({ onClose, fetchData, propData }) => {
    const [form, setForm] = useState({ name: "" });
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [isStudyMaterial, setIsStudyMaterial] = useState("");
    const [state, setState] = useState("");

    useEffect(() => {
        if (propData) {
            setName(propData.medium_name || "");
            setIsStudyMaterial(propData.isStudyMaterial || "");
        }
    }, [propData]);

    const submitHandler = async () => {
        if (!name.trim()) {
            window.NotificationUtils.showError("Please fill in Area fields");
            return;
        }
        // if (isStudyMaterial === "") {
        //     window.NotificationUtils.showError("Please select Study Material option");
        //     return;
        // }

        setLoading(true);
        // Ensure that the values are numbers
        try {
            if (propData) {
                await window.Platform.database.updateOlympiadMedium({
                    medium_name: name,
                    id: propData.id,
                    // isStudyMaterial: isStudyMaterial,
                });
                window.NotificationUtils.showSuccess("Medium updated successfully");
            } else {
                await window.Platform.database.addOlympiadMedium({ 
                    medium_name: name, 
                    // isStudyMaterial: isStudyMaterial, 
                });
                window.NotificationUtils.showSuccess("Medium saved successfully");
            }
            setName("");
            setIsStudyMaterial("");
            fetchData();
            onClose();
        } catch (err) {
            window.NotificationUtils.showError(err?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
            <StyledDialogContent>
                <ModalHeaderContainer>
                    <Typography variant="h5">
                               {propData ? "Update Medium Name" : "Add Medium Name"}
                             </Typography>
                    
                    <IconButton onClick={onClose}>
                        <CloseOutlined />
                    </IconButton>
                </ModalHeaderContainer>

                {loading && <OpaqueLoading />}

                <Stack gap={2} padding={2}>
                    <FormControl fullWidth>

                        <TextField
                            label="Medium Name"
                            value={name || ''}
                            type="text"
                            onChange={(e) => setName(e.target.value)}
                            fullWidth
                        />
                    </FormControl>
                    {/* <FormControl fullWidth className="mt-3">
                        <InputLabel id="study-material-label">Is Study Material</InputLabel>
                        <Select
                            labelId="study-material-label"
                            label="Is Study Material"
                            value={isStudyMaterial}
                            onChange={(e) => setIsStudyMaterial(e.target.value)}
                        >
                            <MenuItem value={"yes"}>Yes</MenuItem>
                            <MenuItem value={"no"}>No</MenuItem>
                        </Select>
                    </FormControl> */}

                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                        <Button
                            color="primary"
                            variant="contained"
                            onClick={submitHandler}
                            disabled={!name}
                        >
                            {propData ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Stack>
            </StyledDialogContent>

        </Dialog>
    );
};

export default OlympiadMediumModal;
